// use 'development' 'or production'
// const env = 'development'
const env = 'production'

const HOST_PRODUCTION = `https://api.kbbank.co.id/backend/api/v1`
const HOST_DEVELOPMENT = `http://10.2.62.64:5000/backend/api/v1`
const HOST_PRODUCTION_DEVELOPMENT = `https://api.kbbank.co.id/api`
const HOST_GLOBAL_DEVELOPMENT = `http://10.2.62.64:5000/api`
const HOST_PIMCORE_PRODUCTION = `https://api.kbbank.co.id/`
const HOST_PIMCORE_DEVELOPMENT = `http://10.2.62.64:5000/`
const variable = {
  HOST: env === 'production' ? HOST_PRODUCTION : HOST_DEVELOPMENT,
  HOST_GLOBAL:
    env === 'production'
      ? HOST_PRODUCTION_DEVELOPMENT
      : HOST_GLOBAL_DEVELOPMENT,
  HOST_PIMCORE:
    env === 'production' ? HOST_PIMCORE_PRODUCTION : HOST_PIMCORE_DEVELOPMENT,
}

export default variable
